import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import moment from "moment"
import VueScrollReveal from 'vue-scroll-reveal'
import {store} from './vuex/store.js'
import VuePageTransition from 'vue-page-transition'
 
// Using ScrollReveal's default configuration
Vue.use(VueScrollReveal);
Vue.use(VuePageTransition)
 
// OR specifying custom default options for all uses of the directive
Vue.use(VueScrollReveal, {
  class: 'v-scroll-reveal', // A CSS class applied to elements with the v-scroll-reveal directive; useful for animation overrides.
  duration: 1050,
  scale: 1,
  distance: '18px',
  mobile: true,
  origin: 'left',
  viewFactor: '0.3'
});

moment.locale("hr")


Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: function (h) { return h(App) }
}).$mount('#app')
